import { api } from "./api";

interface GetShowResultsRequest {
  date?: Temporal.PlainDate | null;
  showTypeId?: string;
  search?: string;
  page?: number;
  pageSize?: number;
}

export const getShowResults = async ({
  date,
  showTypeId,
  search,
  page = 0,
  pageSize = 25,
}: GetShowResultsRequest): Promise<any> => {
  const { data } = await api.get<object>(`/showresults`, {
    params: { date, showTypeId, search, page, pageSize }
  });

  return data;
};

export default {
  getShowResults,
};
